.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 5rem;
  margin: 0 0 0.25rem;
  column-gap: 1.5rem;

  @media (min-width: 769px) {
    height: 4.5rem;
    margin: 0 0 0.25rem;
  }

  @media (min-width: 1025px) {
    margin: 0;
  }

  .logo,
  .back {
    order: 2;
    min-width: 0;
  }

  .back {
    @media (min-width: 1025px) {
      display: none;
    }
  }

  .auth {
    position: relative;
    bottom: 0.0625rem;
    margin: 0;

    .authText {
      padding: 0.5rem 1rem;
    }
  }

  .navigation {
    display: none;
    position: relative;
    order: 1;
    overflow: hidden;
    column-gap: 2rem;

    @media (min-width: 769px) {
      display: flex;
      height: 3.125rem;
      margin: 0 0.625rem;
    }

    @media (min-width: 1025px) {
      margin: 0 0.125rem;
    }

    .link {
      display: flex;
      z-index: 50;
      height: 3rem;
    }

    .underline {
      position: absolute;
      width: 0.125rem;
      height: calc(100% - 0.1875rem);
      border-bottom: 0.1875rem solid var(--neutral-600);
      transition:
        transform 180ms cubic-bezier(0.22, 1, 0.36, 1),
        width 180ms cubic-bezier(0.22, 1, 0.36, 1);
      transform: translateX(-15rem);
      transform-origin: 0 0;
    }

    + .back {
      @media (min-width: 769px) {
        display: none;
      }
    }
  }

  .actions {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    order: 3;
    margin-left: auto;
    gap: 0.625rem;

    @media (min-width: 769px) {
      gap: 0.75rem;
    }

    .profile,
    .settings,
    .notifications {
      width: 2.5rem;
      height: 2.5rem;

      svg {
        width: 1.5rem;
        height: 1.5rem;
      }
    }

    .notifications {
      &:hover {
        .indicator {
          border-color: var(--neutral-200);
        }
      }

      .indicator {
        position: absolute;
        top: 0.5rem;
        left: 0.4375rem;
        width: 0.75rem;
        height: 0.75rem;
        border: 0.225rem solid var(--neutral);
        border-radius: 50%;
        background-color: var(--danger);
      }
    }

    .profile {
      display: none;

      @media (min-width: 769px) {
        display: block;
      }

      .user {
        width: 1.75rem;
        height: 1.75rem;
      }
    }
  }
}
